var map = {
	"./adult/de/6 1 Ordforstaelse Intro.mp3": 868,
	"./adult/nn/6 1 Ordforstaelse Intro.mp3": 869,
	"./adult/no/6 1 Ordforstaelse Intro.mp3": 870,
	"./youth/de/6 1 Ordforstaelse Intro.mp3": 871,
	"./youth/nn/6 1 Ordforstaelse Intro.mp3": 872,
	"./youth/no/6 1 Ordforstaelse Intro.mp3": 873,
	"./youth/se/6 1 Ordforstaelse Intro.mp3": 874
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 867;